import React, { useEffect, useState } from "react";
import { useGetLandingPageMutation } from "../features/auth/apiSlice";
import { Link, useParams } from "react-router-dom";
import { Button, Typography, useTheme } from "@mui/material";
import { tokens } from "../theme";
import Slider from "react-carousel-responsive";
import "react-carousel-responsive/dist/styles.css";

const LandingPage = () => {
  const [getLandingPageAPI] = useGetLandingPageMutation();
  const [landingPage, setLandingPage] = useState({} as any);
  const { sponserId, landingPageId } = useParams();
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [show404, setShow404] = useState(false);

  useEffect(() => {
    const getLandingPage = async () => {
      try {
        const response: any = await getLandingPageAPI({
          sponserId: sponserId,
          landingPageId: landingPageId,
        }).unwrap();

        if (response.status === 200) {
          setLandingPage(response.landingPage);
        }
      } catch (err) {
        setShow404(true);
      }
    };
    getLandingPage();
  }, [getLandingPageAPI, landingPageId, sponserId]);

  const Product = ({ product }: { product: any }) => {
    useEffect(() => {
      const cart = JSON.parse(localStorage.getItem("cart") as string);
      if (cart) {
        if (cart.find((p: any) => p._id === product._id)) {
          setAdded(true);
        }
      }
    }, [product._id]);
    const [added, setAdded] = useState(false);

    const handleAddToCartClicked = () => {
      setAdded(true);
      let cart: any[] = [];
      cart = JSON.parse(localStorage.getItem("cart") as string);
      if (cart === null) {
        localStorage.setItem(
          "cart",
          JSON.stringify([{ ...product, quantity: 1 }])
        );
      } else {
        localStorage.setItem(
          "cart",
          JSON.stringify([...cart, { ...product, quantity: 1 }])
        );
      }
    };
    return (
      <>
        <div key={product?._id} className="w-[300px] mr-5">
          <div className="z-[0] relative">
            <Slider>
              {product?.imgUrls?.map((image: string, i: number) => {
                return (
                  <div className="slide" key={i}>
                    <img
                      className="w-[300px] h-[300px] rounded"
                      src={process.env.REACT_APP_BACKEND_API + "/" + image}
                      alt="product"
                      key={i}
                    />
                  </div>
                );
              })}
            </Slider>
          </div>
          <div className="flex justify-center">
            <Typography variant="h4">{product?.title}</Typography>
          </div>
          <Typography variant="h5">{product?.description}</Typography>
          <div className="flex justify-between items-center">
            <Typography variant="h4">
              Price: {product?.price + "Rs/-"}
            </Typography>
            {!added ? (
              <Button
                variant="contained"
                onClick={() => handleAddToCartClicked()}
              >
                Add to Cart
              </Button>
            ) : (
              <Typography variant="h4">Added to cart</Typography>
            )}
          </div>
        </div>
      </>
    );
  };

  return (
    <div>
      <header>
        <nav
          className="flex justify-between p-2"
          style={{ backgroundColor: colors.blueAccent[300] }}
        >
          <div>
            <Link
              to={"/home"}
              state={{
                home: window.location.href,
                sponserId: sponserId,
                landingPageId: landingPageId,
              }}
            >
              Home
            </Link>
          </div>
          <div>
            <Link
              className="mr-5"
              to={"/orders"}
              state={{
                home: window.location.href,
                sponserId: sponserId,
                landingPageId: landingPageId,
              }}
            >
              Orders
            </Link>
            <Link
              to={"/cart"}
              state={{
                home: window.location.href,
                sponserId: sponserId,
                landingPageId: landingPageId,
              }}
            >
              Cart
            </Link>
          </div>
        </nav>
      </header>
      <main>
        {show404 ? (
          <Typography
            variant="h1"
            className="h-[100vh] flex justify-center items-center"
          >
            404 Page not found!
          </Typography>
        ) : (
          <>
            <div className="flex flex-wrap p-5">
              {landingPage?.products?.map((product: any) => {
                return <Product key={product._id} product={product} />;
              })}
            </div>
          </>
        )}
      </main>
      <footer></footer>
    </div>
  );
};

export default LandingPage;
